import React, { Fragment, useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Unstable_Grid2";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import SystemUpdateAltIcon from "@mui/icons-material/SystemUpdateAlt";
import IconButton from "@mui/material/IconButton";
import PolicyContext from "../../../context/policy/PolicyContext";
import RichTextBoxEditer from "../../../components/RichTextBoxEditer";
import DialogBoxComponent from "../../../components/DialogBoxComponent";
import {
  alpha,
  Box,
  Button,
  CircularProgress,
  ListItemIcon,
  Menu,
  MenuItem,
  MenuProps,
  Stack,
  styled,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  EditPlan,
  PlanImport,
  DeletePlan,
} from "../../../assets/RiskManagementIcon";
import { useIncidentResponsePlanContext } from "../../../context/IncidentResponsePlan/IncidentPlanResponceContext";
import {
  deleteIRPTest,
  downloadFiles,
  fetchIRPTestPreview,
  getIRPTestFileDelete,
  getIRPTestFiles,
  getIRPTestFilesDownload,
  downloadAllTestFiles,
  EditIRPTestPreview,
} from "../helper";
import RichTextBoxTabPanel from "../../../components/RichTextBoxEditerTabs";
import { IRPTestPreview, IRPTestFiles } from "../modal";
import { useUserContext } from "../../../context/auth/UserContext";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile"; // File icon
import DownloadIcon from "@mui/icons-material/Download";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import MenuList from "@mui/material/MenuList";
import { useAccessRights } from "../../../utils/useAccessRights";
import { getUserName } from "../../../helper/helper";

export const DisplayResponseTests = (props: {
  loadingPage: boolean;
  refreshList: () => void;
}) => {
  const navigate = useNavigate();
  const incidentResponseTestAccess = useAccessRights("Incident Response Tests");

  const { userId, companyProfileID } = useUserContext();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const ITEM_HEIGHT = 48;

  const [testDetails, setTestDetails] = useState<IRPTestPreview>();
  const [fileList, setFileLists] = useState<IRPTestFiles[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFileLoading, setIsFileLoading] = useState(false);
  const [dialogState, setDialogState] = useState({
    title: "",
    body: "",
    action: "",
    actionCancel: "",
    openDeleteConfirmationDialog: false,
    openSuccessDialogBox: false,
  });
  const tabDetalis = [
    {
      label: "description",
      key: "description",
      id: `tab-description`,
      editerValue: testDetails?.description ? testDetails.description : "",
    },
    {
      label: "detection",
      key: "detection",
      id: `tab-detection`,
      editerValue: testDetails?.detection ? testDetails.description : "",
    },
    {
      label: "analysis",
      key: "analysis",
      id: `tab-analysis`,
      editerValue: testDetails?.analysis ? testDetails.analysis : "",
    },
    {
      label: "containment",
      key: "containment",
      id: `tab-containment`,
      editerValue: testDetails?.containment ? testDetails.containment : "",
    },
    {
      label: "eradication",
      key: "eradication",
      id: `tab-eradication`,
      editerValue: testDetails?.eradication ? testDetails.eradication : "",
    },
    {
      label: "recovery",
      key: "recovery",
      id: `tab-recovery`,
      editerValue: testDetails?.recovery ? testDetails.recovery : "",
    },
    {
      label: "lessons learned",
      key: "lessonsLearned",
      id: `tab-lessonsLearned`,
      editerValue: testDetails?.lessonsLearned
        ? testDetails.lessonsLearned
        : "",
    },
    {
      label: "Parties Contacted",
      key: "partiesContacted",
      id: `tab-partiesContacted`,
      editerValue: testDetails?.partiesContacted
        ? testDetails.partiesContacted
        : "",
    },
  ];
  const {
    selectedIRPTestPreview,
    setSelectedIRPTestPreview,
    isFileRefresh,
    setIsFileRefresh,
    setIRPTestDetails,
  } = useIncidentResponsePlanContext();

  const displayEditTest = async (details: any) => {
    const date = new Date();
    const payload = [
      {
        ...details,
        isEditedByUser: true,
        isEditedByUserId: userId + "",
        updateBy: userId,
        updateDate: date,
      },
    ];

    const resUpdate = await EditIRPTestPreview(payload);
    if (resUpdate.succeeded === true) {
      navigate("/incident-response-test-form", {
        state: { action: "Edit", editData: testDetails },
      });
    }
  };

  const handleEditTest = async () => {
    const res = await fetchIRPTestPreview(selectedIRPTestPreview.testID);

    // console.log("handleEditPlan plan", res);
    if (res.isEditedByUser && parseInt(res.isEditedByUserId) !== userId) {
      let userName = await getUserName(res.isEditedByUserId);
      setDialogState({
        title: "Info",
        body: `You are unable to modify this plan because ${userName} has already begun editing it.`,
        action: "Ok",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      displayEditTest(res);
    }
  };

  const handleCloseDialog = () => {
    if (dialogState.title === "Success") {
      props.refreshList();
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    } else {
      setDialogState({
        ...dialogState,
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: false,
      });
    }
    setTestDetails(undefined);
    setSelectedIRPTestPreview(null);
  };

  const handleDeleteTest = async () => {
    setTestDetails(undefined);
    setDialogState(() => ({
      ...dialogState,
      openDeleteConfirmationDialog: false,
      openSuccessDialogBox: false,
    }));
    const res = await deleteIRPTest(userId, selectedIRPTestPreview.testID);
    if (res.succeeded === true) {
      setDialogState({
        title: "Success",
        body: `${selectedIRPTestPreview.testName} successfully deleted`,
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    } else {
      setDialogState({
        title: "Error",
        body: "Unexpected Error",
        action: "OK",
        actionCancel: "",
        openDeleteConfirmationDialog: false,
        openSuccessDialogBox: true,
      });
    }
  };

  const confirmDelete = () => {
    setDialogState({
      title: "Confirmation",
      body: `Are you sure you want to delete ${selectedIRPTestPreview?.testName}?`,
      action: "Delete",
      actionCancel: "Cancel",
      openDeleteConfirmationDialog: true,
      openSuccessDialogBox: false,
    });
  };

  const fetchPreview = async () => {
    setIsLoading(true);
    try {
      let res = await fetchIRPTestPreview(selectedIRPTestPreview.testID);

      const formattedList = {
        ...res,
        rowId: res.testType,
      };
      setTestDetails(formattedList);
      setIRPTestDetails(formattedList);
    } finally {
      setIsLoading(false);
    }
  };
  const fetchFiles = async () => {
    setIsLoading(true);
    setIsFileLoading(true);
    try {
      let res: IRPTestFiles[] = await getIRPTestFiles(
        selectedIRPTestPreview.testID
      );
      setFileLists(res);
    } finally {
      setIsLoading(false);
      setIsFileRefresh(false);
      setIsFileLoading(false);
    }
  };

  const handleDownloadTest = async () => {
    let res = await downloadAllTestFiles(testDetails, userId, companyProfileID);
    // console.log("handleDownloadFiles res", res, testDetails);
  };

  const handleViewFilesClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseViewFiles = () => {
    setAnchorEl(null);
  };

  const truncateFileName = (fileName: string | any[], maxLength: number) => {
    if (fileName.length <= maxLength) return fileName;
    const start = fileName.slice(0, Math.ceil(maxLength / 2));
    const end = fileName.slice(-Math.floor(maxLength / 2));
    return `${start}...${end}`;
  };
  const handleDownloadFiles = (file: any) => {
    getIRPTestFilesDownload(file);
  };

  const handleDeleteFile = async (file: IRPTestFiles) => {
    setIsFileLoading(true);
    try {
      const payload = {
        testID: file.testID,
        fileIds: [file.testFilesInformationID],
      };
      const res = await getIRPTestFileDelete(payload);

      if (!res.message) {
        setAnchorEl(null);
        setDialogState({
          title: "Error",
          body: "An error occurred while deleting the folder.",
          action: "OK",
          actionCancel: "",
          openDeleteConfirmationDialog: false,
          openSuccessDialogBox: false,
        });
      }
    } finally {
      fetchFiles();
    }
  };

  useEffect(() => {
    if (!props.loadingPage && selectedIRPTestPreview) {
      fetchPreview();
      fetchFiles();
    } else {
      setFileLists([]);
      setIRPTestDetails({});
      setTestDetails(undefined);
    }
  }, [selectedIRPTestPreview]);

  useEffect(() => {
    if (isFileRefresh && selectedIRPTestPreview) {
      fetchFiles();
    }
  }, [isFileRefresh]);

  return (
    <Fragment>
      <Grid sx={{ height: "100%", width: "100%" }}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid>
            <h3 style={{ fontWeight: "400", opacity: "80%" }}>
              {selectedIRPTestPreview?.testName}
            </h3>
          </Grid>
          <Grid>
            <Stack direction="row" spacing={1}>
              <div>
                <Button
                  size="small"
                  variant="contained"
                  className="table-btn"
                  onClick={handleViewFilesClick}
                  disabled={!selectedIRPTestPreview}
                >
                  View Files
                </Button>
              </div>
              <Menu
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                slotProps={{
                  paper: {
                    style: {
                      maxHeight: ITEM_HEIGHT * 4.5,
                      minWidth: "350px", // Minimum width for the menu
                    },
                  },
                }}
                open={Boolean(anchorEl)}
                onClose={handleCloseViewFiles}
                MenuListProps={{
                  "aria-labelledby": "view-files-button",
                }}
              >
                {isFileLoading ? (
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <CircularProgress />
                  </Box>
                ) : fileList.length > 0 ? (
                  fileList.map((file) => (
                    <Tooltip
                      title={
                        file.testFileName.length > 39 ? file.testFileName : null
                      }
                      key={file.testFilesInformationID}
                    >
                      <MenuList
                        key={file.testFilesInformationID}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          display: "flex",
                        }}
                      >
                        <MenuItem
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            cursor: "default",
                          }}
                        >
                          <AttachFileIcon fontSize="small" color="primary" />
                          <Typography
                            variant="body2"
                            sx={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              flexGrow: 1,
                              maxWidth: "230px", // Adjust to control width of file name
                            }}
                            color="primary"
                          >
                            {truncateFileName(file.testFileName, 40)}
                          </Typography>
                          <IconButton
                            size="small"
                            sx={{ marginLeft: "auto" }}
                            onClick={() => handleDownloadFiles(file)}
                          >
                            <DownloadIcon fontSize="small" color="inherit" />
                          </IconButton>
                          <Tooltip title="Delete File">
                            <IconButton
                              size="small"
                              aria-label="delete"
                              onClick={() => handleDeleteFile(file)}
                            >
                              {React.createElement(DeletePlan)}
                            </IconButton>
                          </Tooltip>
                        </MenuItem>
                      </MenuList>
                    </Tooltip>
                  ))
                ) : (
                  <MenuList
                    style={{
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                      display: "flex",
                    }}
                  >
                    <MenuItem>
                      <Typography
                        variant="body2"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                      >
                        No files available.
                      </Typography>
                    </MenuItem>
                  </MenuList>
                )}
              </Menu>

              <Tooltip title="Download Test">
                <IconButton
                  onClick={handleDownloadTest}
                  disabled={
                    !selectedIRPTestPreview ||
                    !incidentResponseTestAccess?.isDownload
                  }
                  aria-label="download"
                >
                  {React.createElement(PlanImport, {
                    opacity:
                      !selectedIRPTestPreview ||
                      !incidentResponseTestAccess?.isDownload
                        ? "50%"
                        : "100%",
                  })}
                </IconButton>
              </Tooltip>
              <Tooltip title="Edit Test">
                <IconButton
                  disabled={
                    !selectedIRPTestPreview ||
                    !incidentResponseTestAccess?.isUpdate
                  }
                  aria-label="edit"
                  onClick={handleEditTest}
                >
                  {React.createElement(EditPlan, {
                    opacity:
                      !selectedIRPTestPreview ||
                      !incidentResponseTestAccess?.isUpdate
                        ? "50%"
                        : "100%",
                  })}
                </IconButton>
              </Tooltip>
              <Tooltip title="Delete Test">
                <IconButton
                  disabled={
                    !selectedIRPTestPreview ||
                    !incidentResponseTestAccess?.isDelete
                  }
                  aria-label="delete"
                  onClick={confirmDelete}
                >
                  {React.createElement(DeletePlan, {
                    opacity:
                      !selectedIRPTestPreview ||
                      !incidentResponseTestAccess?.isDelete
                        ? "50%"
                        : "100%",
                  })}
                </IconButton>
              </Tooltip>
            </Stack>
          </Grid>
        </Grid>
        <Grid>
          <h5
            style={{
              margin: "0.5rem 0",
              color: "lightgrey",
              fontStyle: "italic",
            }}
          >
            Overview
          </h5>
          {isLoading ? (
            <Box display="flex" justifyContent="center">
              <CircularProgress />
            </Box>
          ) : (
            <h5
              style={{
                margin: "0.5rem 0",
                fontWeight: "400",
              }}
            >
              <RichTextBoxTabPanel
                readonly={true}
                tabs={tabDetalis}
                handleTabEditerChange={() => {}}
              />
            </h5>
          )}
        </Grid>
      </Grid>
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openSuccessDialogBox}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogBody={dialogState.body}
          handleFunction={handleCloseDialog}
        />
      }
      {
        <DialogBoxComponent
          openDialogBox={dialogState.openDeleteConfirmationDialog}
          dialogTitle={dialogState.title}
          dialogAction={dialogState.action}
          dialogActionCancel={dialogState.actionCancel}
          dialogBody={dialogState.body}
          handleFunction={handleDeleteTest}
          handleCancel={handleCloseDialog}
        />
      }
    </Fragment>
  );
};
